import script from "./PCPartsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./PCPartsTab.vue?vue&type=script&setup=true&lang=js"

import "./PCPartsTab.vue?vue&type=style&index=0&id=521f6fae&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-521f6fae"]])

export default __exports__